import type { Static } from 'runtypes';
import { InstanceOf, Number, Record, String } from 'runtypes';

const AiCardShorthandRuntype = Record({
  timestamp: InstanceOf(Date),
  user_id: Number,
  email: String,
  session_id: String,
  event: String,
  node_id: Number,
  original_text: String,
  summary_text: String,
});

type AiCardShorthandType = Static<typeof AiCardShorthandRuntype>;

export { AiCardShorthandRuntype };
export type { AiCardShorthandType };
